'use client';

import type { AttributesEntity } from '@eliadmin/core/src/api/products/types/product-types';
import React from 'react';

export function ProductAttributes({ attributes }: { attributes?: AttributesEntity[] }) {
  const materials = attributes?.find(a => a.id === 2)?.values ?? [];

  if (materials.length > 0) return (
    <div className='flex items-center justify-start gap-1'>
      {materials.map((attribute, index) => (
        <React.Fragment key={attribute.name}>
          {index !== 0 && (
            <div className='w-1 h-1 rounded-full bg-border' />
          )}
          <p className='text-[10px] sm:text-xs font-normal text-[#666666]'>
            {attribute.name}
          </p>
        </React.Fragment>
      ))}
    </div>
  );
}
